import { render, staticRenderFns } from "./contentPreview.vue?vue&type=template&id=45bb6f73&scoped=true&"
import script from "./contentPreview.vue?vue&type=script&lang=js&"
export * from "./contentPreview.vue?vue&type=script&lang=js&"
import style0 from "./contentPreview.vue?vue&type=style&index=0&id=45bb6f73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb6f73",
  null
  
)

export default component.exports